import mergeCarts from './mergeCarts';

export default mergeCarts;
